import React, { lazy, Suspense } from 'react';
export var useAsyncComponent = function useAsyncComponent(component, props, key) {
  var Component = /*#__PURE__*/lazy(component);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null,
    key: key
  }, /*#__PURE__*/React.createElement(Component, props));
};